export const COLUMNS: string[] = [
	'pages.packages.name', 'pages.packages.description', 'pages.packages.weight', 'pages.packages.volume', 'pages.packages.loadingTime', 'pages.packages.unloadingTime', '',
];

export const SELECTORS: string[] = [
	'name', 'description', 'weight', 'volume', 'loading_service_time', 'unloading_service_time'
];
